import { useEffect } from "react";
import type { StoreDocuments } from "../../StoreDocuments";
import type { StoreOtherDocumentForm } from "./StoreOtherDocumentForm";

export const useOptions = (
  store: StoreOtherDocumentForm,
  documentsStore: StoreDocuments,
) => {
  useEffect(() => {
    store.projectOptions = documentsStore.projects;
    store.clientOptions = documentsStore.clients;
    store.contractorOptions = documentsStore.contractors;
    store.brandOptions = documentsStore.brands;
  }, [
    documentsStore.projects,
    documentsStore.clients,
    documentsStore.contractors,
    documentsStore.brands,
  ]);
};
